import { render, staticRenderFns } from "./TeamsNotReadyDialog.vue?vue&type=template&id=f47bd67c"
import script from "./TeamsNotReadyDialog.vue?vue&type=script&lang=js"
export * from "./TeamsNotReadyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports